// // ProtectedRoute.js
// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from './AuthContext';

// const ProtectedRoute = ({ children }) => {
//     const { isAuthenticated } = useAuth();

//     if (!isAuthenticated) {
//         return <Navigate to="/" />;
//     }
//     return children;

// };

// export default ProtectedRoute;


import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const accessToken = localStorage.getItem("accessToken");

const ProtectedRoute = ({ children }) => {
  const { token } = useSelector((state) => state.store);

  if (!accessToken && !token) {
    return <Navigate to={"/"} />;
  }

  return children;
};

export { ProtectedRoute };

const AuthProtected = ({ children }) => {
  const { token } = useSelector((state) => state.store);

  if (token) {
    return <Navigate to={"/app"} replace />;
  }

  return children;
};

export { AuthProtected };
